import { render, staticRenderFns } from "./BuyRDModal.vue?vue&type=template&id=e2ae18e4&"
import script from "./BuyRDModal.vue?vue&type=script&lang=js&"
export * from "./BuyRDModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports